import styled from 'styled-components';
import { Field, ErrorMessage } from 'formik';

const FieldErrorContainer = styled.div`
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  padding: 10px 10px;

  width: 50%;

`

const FieldLabel = styled.label`
  color: #82A194;
  font-weight: 400;
`

const StyledField = styled(Field)`
  margin: 1em 0;
  padding: 1.25em 1.25em;
  border-radius: 3px;
  border: none;
  background: #C7D0C7;
  font-size: 1em;
`

const FieldWithErrorDisplay = (props) => {
  return (
    <FieldErrorContainer>
      <FieldLabel htmlFor={props.labelFor}>{props.label}</FieldLabel>
      <StyledField
        name={props.labelFor}
        type={props.type}
      />
      <ErrorMessage
        name={props.labelFor}
        component="div"
        className="field-error"
      />
    </FieldErrorContainer>
  )
}

export default FieldWithErrorDisplay;
